import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from './auth.reducer';

export const selectAuthState = createFeatureSelector<AuthState>('auth');

export const selectIsAuthenticated = createSelector(
  selectAuthState,
  (s) => s.status === 'authenticated',
);
export const selectIsVerifying = createSelector(
  selectAuthState,
  (s) => s.status === 'verifying',
);
export const selectPin = createSelector(selectAuthState, (s) => s.pin);
export const selectPinError = createSelector(selectAuthState, (s) => s.error);
export const selectStaffIdx = createSelector(selectAuthState, (s) => s.staffIdx);

export const selectAuthToken = createSelector(selectAuthState, (s) => s.token);
export const selectAccountId = createSelector(selectAuthState, (s) => s.accountId);
export const selectStoreId = createSelector(selectAuthState, (s) => s.storeId);
export const selectTerminalId = createSelector(selectAuthState, (s) => s.terminalId);
export const selectStoreInfo = createSelector(selectAuthState, (s) => s.storeInfo);
export const selectAssetName = createSelector(selectAuthState, (s) => s.assetName);
